import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const getMlsTypeFilterOptions = async () => {
  const config: AxiosRequestConfig = {
    url: '/answering/mls_types',
    method: 'get',
  };

  const { data } = await axios.request<string[]>(config);
  return data;
};

export default getMlsTypeFilterOptions;
